import { Spinner } from "@afterpaytouch/core";
import classnames from "classnames/bind";
import React from "react";
import Lottie from "react-lottie-player";

import { useIsArcade } from "@/hooks/useIsArcade";

import LogoAnimation from "../../assets/animations/mint-logo-transparent-bg.json";
import styles from "./loader.module.scss";

const cx = classnames.bind(styles);

const Loader: React.FC = () => {
    const isArcade = useIsArcade();
    const loaderClassName = cx({
        [styles.loaderContainer]: true,
        [styles.loaderContainerArcade]: isArcade,
    });
    return (
        <div className={loaderClassName}>
            {isArcade ? (
                <Spinner />
            ) : (
                <Lottie
                    animationData={LogoAnimation}
                    rendererSettings={{
                        preserveAspectRatio: "xMidYMid slice",
                    }}
                    loop
                    play
                />
            )}
        </div>
    );
};

export default Loader;
